import UserPhoneNumberFormRenderer from '../../../../../UserPhoneNumbers/Modals/UserPhoneNumberModal/Form/Renderer';

/**
 * KYC User Identity Form Content Phone Number Look Up Component
 * Renders a phone number form component specifically for KYC flow with minimal UI
 *
 * @component
 * @param {Object} props - Component props
 * @param {boolean} [props.isContainerColor] - Whether to use container background color styling
 * @returns {JSX.Element} Phone number form renderer component
 *
 * @example
 * // Basic usage
 * <KYCUserIdentityFormContentPhoneNumberLookUp
 *   isContainerColor={true}
 * />
 *
 * // Without container color
 * <KYCUserIdentityFormContentPhoneNumberLookUp
 *   isContainerColor={false}
 * />
 */
export default function KYCUserIdentityFormContentPhoneNumberLookUp({
  isContainerColor,
}: {
  isContainerColor?: boolean;
}) {
  return (
    <UserPhoneNumberFormRenderer
      useMinimalForm
      isKycFlow
      isContainerColor={isContainerColor}
    />
  );
}
